if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "anonymous";
	}

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"wp-runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"primer-react":1,"app_assets_modules_react-code-view_components_blob-edit_BlobEditor_tsx-ui_packages_web-commit-fb78e1":1,"ui_packages_web-commit-dialog_WebCommitDialog_module_css":1,"ui_packages_copilot-for-business_routes_Policies_tsx":1,"ui_packages_copilot-for-business_routes_SeatManagement_tsx-ui_packages_copilot-for-business_c-ae51d3":1,"ui_packages_copilot-for-business_routes_StandaloneSeatManagement_tsx-ui_packages_copilot-for--522120":1,"ui_packages_aria-live_aria-live_ts-ui_packages_test-id-props_test-id-props_ts-ui_packages_use-53c741":1,"ui_packages_mergebox_components_sections_merge-section_command-line-instructions_CommandLineI-e41d4a":1,"node_modules_focus-visible_dist_focus-visible_js-ui_packages_test-id-props_test-id-props_ts-u-b1e150":1,"app_components_stafftools_react_TanstackQueryDevtools_StaffBarReactQueryDevToolsPanel_tsx":1,"node_modules_github_mini-throttle_dist_index_js-node_modules_stacktrace-parser_dist_stack-tra-643161":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded